import '../sass/index.scss';
// import { BaseView, BaseD3View } from './lib/base.js';
var $ = require('jquery');

// randomizesample
import {randomizesample} from './randomizesample';


  // timer
	var intervals;
	var toggleValue = true;
	var curItemIndex = -1;
	var timing = 7500;
	var delay = 100;


  // flashing graphic visual effects
  var graphic = {
  		yellowflash: function(){
  			$(".highlight-text").removeClass("yellowflash");
  		    setTimeout(function() {
  		        $(".highlight-text").addClass("yellowflash");
  		    }, 1);
  		},
  		grayflash: function(){
  			$(".highlight-text").removeClass("yellowflash");
  		    setTimeout(function() {
  		        $(".highlight-text").addClass("yellowflash");
  		    }, 1);
  		}
  	}


	var timer = {
		init: function(){
			timer.actions();
			timer.animateBar();
			intervals = setInterval(function(value, index){


						timer.actions();
						timer.animateBar();

					}, timing);

			timer.assignHandler();

		},
		actions: function() {
      // these actions will be performed during the timer
			++curItemIndex;
			if (curItemIndex >= randomizesample.length) {
				curItemIndex = 0;
			}

			// make things flash
			graphic.yellowflash();
			graphic.grayflash();

			// change terms
			$('#question').html(randomizesample[curItemIndex].alert);
			$('#who').text(randomizesample[curItemIndex].description);
			$('.highlight-text').text(randomizesample[curItemIndex].quote);

		},
		animateBar: function(){
      $('.progress-bar').animate({width: "100%"}, timing-delay, function(){
        $('.progress-bar').css("width", "0px")
      });
		},
		halt: function() {
			toggleValue = false;
		    clearInterval(intervals);
		},
		assignHandler: function(){
			$('.playButton').on("click", function(){
				if (toggleValue == true){

					$('.playButton').html(' play <span class="progress-bar"></span>');
					timer.halt();
				} else{
					timer.animateBar();
					timer.actions();
					toggleValue = true;
					$('.playButton').html(' pause <span class="progress-bar"></span>');
					$('.progress-bar').css("width", "0px");
					$('.progress-bar').delay( delay ).animate({width: "100%"}, timing - delay -200);
					intervals = setInterval(function(){
						timer.actions();
						timer.animateBar();
					}, timing);
				}
			})

		}

	}

// initialize timer
timer.init();



// WEBPACK FOOTER //
// js/index.js